module.exports = __webpack_public_path__ + "img/introduction_bg1.8f3ca70b.png";